import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { resetQueries } from '@/utils'

import { RESERVATION_NOTES_QUERY_KEY } from './get-reservation-notes'

export type CreateReservationNoteRequest = {
  reservationId: string
  title: string
  noteBody: string
}

const createReservationNote = async ({
  reservationId,
  title,
  noteBody,
}: CreateReservationNoteRequest) => {
  const result = await authAPI.post(`/reservation/${reservationId}/notes`, { noteBody, title })

  return result.data
}

export const useCreateReservationNote = () => {
  return useMutation({
    mutationFn: createReservationNote,
    onError: () => {
      toastFactory.error(i18n.t('common:errors.generic'))
    },
    onSuccess: async () => {
      await resetQueries([RESERVATION_NOTES_QUERY_KEY])
      toastFactory.success(i18n.t('reservations:details.apiMessages.createSuccess'))
    },
  })
}
